export default {"src":"/venues/_next/static/media/icons.0ebe026b.svg","height":0,"width":0,"blurWidth":0,"blurHeight":0};